export default "__VITE_ASSET__bebac215__"